/* eslint-disable @typescript-eslint/no-unused-vars */
'use client';

import {
  IconLabel,
  Breadcrumbs as AhuaBreadcrumb,
} from '@yaradigitallabs/ahua-react';
import React from 'react';
import { Link } from 'react-router-dom';

type BreadcrumbItem = {
  label: string;
  url?: string;
};

interface BreadcrumbProps {
  list: Array<BreadcrumbItem>;
  className?: string;
}

export const CustomBreadcrumb: React.FC<BreadcrumbProps> = ({
  list,
  className = '',
}) => {
  return (
    <nav
      aria-label="Breadcrumb"
      className={`px-4 flex justify-start items-center bg-white gap-2 [&>div]:gap-2 [&>div>svg]:min-w-[16px]! [&>div>svg]:w-[16px]! ${className}`.trim()}
    >
      {list.map((item, index, array) => (
        <IconLabel
          key={`breadcrumb_${index}`}
          label={
            array.length - 1 === index || !item.url ? (
              item.label
            ) : (
              <Link
                to={item.url || '#'}
                className="font-medium text-[#06C] hover:underline"
              >
                {item.label}
              </Link>
            )
          }
          labelPosition="left"
          showIcon={array.length - 1 !== index}
          className="truncate whitespace-nowrap overflow-hidden min-w-0"
          {...(array.length - 1 === index && { 'aria-current': 'page' })}
        />
      ))}
    </nav>
  );
};

const BreadcrumbTwo: React.FC<BreadcrumbProps> = ({ list }) => {
  // const [open, setOpen] = useState(false);

  const shouldCollapse = list.length > 4;

  const first = list[0];
  const middle = list.slice(1, -2);
  const lastTwo = list.slice(-2);

  return (
    <div className="flex items-center gap-2 text-sm text-gray-700">
      {/* First Item */}
      {/* <BreadcrumbLink item={first} /> */}
      <IconLabel
        label={
          list.length === 1 ? (
            first.label
          ) : (
            <a
              href={first.url}
              className="font-medium text-[#06C] hover:underline"
            >
              {first.label}
            </a>
          )
        }
        labelPosition="left"
        showIcon={list.length - 1 !== 0}
      />

      {/* Separator */}
      {/* {list.length > 1 && <Separator />} */}

      {/* Collapsed Items */}
      {shouldCollapse && (
        <>
          <IconLabel
            label={
              <div className="relative group">
                <button
                  //   onClick={() => setOpen(prev => !prev)}
                  className="rounded px-2 py-1 hover:bg-gray-100"
                >
                  ...
                </button>

                {/* {open && ( */}
                <div className="absolute -left-10 top-0 z-50 p-4 rounded-md border border-gray-200 bg-white shadow-lg hidden group-hover:flex flex-col gap-2 ">
                  {middle.map((item, index) => (
                    <IconLabel
                      key={`breadcrumb-collapse-${index}`}
                      label={
                        <a
                          href={item.url}
                          className="font-medium text-[#06C] hover:underline"
                        >
                          {item.label}
                        </a>
                      }
                      labelPosition="left"
                      showIcon={false}
                    />
                  ))}
                </div>
                {/* )} */}
              </div>
            }
            labelPosition="left"
          />
        </>
      )}

      {/* Normal Rendering When Small */}
      {!shouldCollapse &&
        list.slice(1, -1).map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            <IconLabel
              label={
                list.length === 1 ? (
                  first.label
                ) : (
                  <a
                    href={item.url}
                    className="font-medium text-[#06C] hover:underline"
                  >
                    {item.label}
                  </a>
                )
              }
              labelPosition="left"
              showIcon={list.length - 1 !== 0}
            />

            {/* <BreadcrumbLink item={item} />
            <Separator /> */}
          </div>
        ))}

      {/* Last Two */}
      {lastTwo.map((item, index) => {
        const isLast = index === lastTwo.length - 1;

        return (
          <div key={index} className="flex items-center gap-2">
            <IconLabel
              label={
                isLast ? (
                  item.label
                ) : (
                  <a
                    href={item.url}
                    className="font-medium text-[#06C] hover:underline"
                  >
                    {item.label}
                  </a>
                )
              }
              labelPosition="left"
              showIcon={!isLast}
            />
            {/* <BreadcrumbLink item={item} isActive={isLast} /> */}

            {/* {!isLast && <Separator />} */}
          </div>
        );
      })}
    </div>
  );
};

/*

To be removed once Breadcrumb component is Stable. Below code are trial components used during development.
function Separator() {
  return <span className="text-gray-400">/</span>;
}

function BreadcrumbLink({
  item,
  isActive = false,
}: {
  item: BreadcrumbItem;
  isActive?: boolean;
}) {
  return (
    <a
      href={item.url}
      className={`
        max-w-[180px]
        truncate
        whitespace-nowrap
        ${
          isActive
            ? 'font-semibold text-black'
            : 'text-gray-500 hover:text-black'
        }
      `}
    >
      {item.label}
    </a>
  );
}

*/

type BreadcrumbTwoProps = React.ComponentProps<typeof AhuaBreadcrumb>;
const Breadcrumbs: React.FC<BreadcrumbTwoProps> = ({
  className = '',
  ...props
}) => {
  return (
    <div
      className={`px-4 flex justify-start items-center bg-white gap-2 [&>nav]:flex! [&>nav>a]:text-sm! [&>nav>span]:text-sm! [&>nav>a]:text-[#06C]! [&>nav>a]:hover:underline [&>nav>a:first-child>span>svg]:hidden! [&>nav>span:last-child]:text-gray-500! [&>nav>span>svg]:min-w-[16px]! [&>nav>span>svg]:w-[16px]! ${className}`.trim()}
    >
      <AhuaBreadcrumb {...props} />
    </div>
  );
};

export default Breadcrumbs;
